// extracted by mini-css-extract-plugin
export var statItem = "_ia-1";
export var statsRow = "_ia-0";